import React, { Component } from 'react'

import MenuItem from '@material-ui/core/MenuItem';

import { SelectInput } from '../Inputs'


export class EnumSelectInput extends Component {

    renderChildren() {
        if (this.props.choices.length === 0){
            return <MenuItem value={''}></MenuItem>
        } else {
            return this.props.choices.map((value) => {
                return <MenuItem key={value} value={value}>{value}</MenuItem>
            })
        }
    }

    render() {
        return (
            <SelectInput {...this.props}>
                {this.renderChildren()}
            </SelectInput>
        )
    }
}
